/** @jsx jsx */
import { jsx, Container, Heading, Grid, Box, Image } from 'theme-ui'
import { FC, Fragment } from 'react'
import { space } from '~/gatsby-plugin-theme-ui'
import { ButtonRugs } from '~/components/button-rug-collections'
import { FeaturedCollectionType, FluidImageObjectType } from '~/@types/models'
import ProductCarousel from '~/components/products-carousel'
import SliderArrowCustom from '~/components/products-carousel/chevron-arrow'
import { graphql, Link, useStaticQuery } from 'gatsby'
import contemporaryRugCategories from '../../../static/media/contemporary-rug-categories.jpg'
import ArrowSecondary from '~/components/arrow-secondary'

type Props = {
  featuredCollectionsList: FeaturedCollectionType[]
}

const arrowSpace = 10
const prevArrow = <ArrowSecondary arrowSpace={arrowSpace} top="47%" direction="left" />
const nextArrow = <ArrowSecondary arrowSpace={arrowSpace} top="47%" direction="right" />
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
const MobileCollectionCarousel: FC<Props> = ({ featuredCollectionsList }) => {
  return (
    <ProductCarousel
      variant="primary"
      settings={{
        dots: false,
        arrows: true,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        slidesToShow: 6,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      }}
      carouselSx={{
        '.slick-list': {
          margin: '0 -6px',
        },
        '.slick-slide': {
          padding: '0 6px',
        },
      }}
      data={featuredCollectionsList.map((item, key) => {
        const featuredCollection = item?.handle ? item : item.node
        return () => (
          <Box key={key}>
            <Link
              to={`/collections/${featuredCollection.handle}`}
              sx={{
                '&:hover': {
                  '#collection-link': {
                    display: 'flex !important',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#777777',
                    opacity: 0.35,
                  },
                },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  aspectRatio: '235/160',
                  overflow: 'hidden',
                  width: '100%',
                  img: {
                    width: '100%',
                    height: '100%',
                  },
                }}
              >
                <Image
                  src={
                    featuredCollection.metafields?.collectionCustomImageUrl === null
                      ? contemporaryRugCategories
                      : featuredCollection.metafields?.collectionCustomImageUrl
                  }
                  alt={featuredCollection.title || 'Collection Image'}
                />
              </Box>
              <Box
                sx={{
                  mt: space.sm,
                }}
              >
                <ButtonRugs
                  label={featuredCollection.title}
                  type="button"
                  hasArrow={false}
                  to={`/collections/${featuredCollection.handle}`}
                  sx={{
                    width: '175px !important',
                    height: '20px !important',
                    minHeight: 10,
                    fontSize: '12px',
                    minWidth: '150px !important',
                    color: '#595858',
                    backgroundColor: 'transparent',
                    borderStyle: 'none',
                    textAlign: 'left',
                    padding: 0,
                    textTransform: 'uppercase',
                  }}
                />
              </Box>
            </Link>
          </Box>
        )
      })}
    />
  )
}
export default MobileCollectionCarousel
